import { Link } from 'react-router-dom'
import { Icon } from '@iconify/react'
import { ASSISTANT_SERVICES } from './services'
import './AssistantPage.css'

/**
 * Хаб инструментов: сетка иконок в стиле рабочего стола телефона.
 * Состав сетки задаётся в `services.ts` — вёрстка от него не зависит.
 */
const AssistantPage = () => (
  <div className="assistant-page">
    <div className="assistant-body">
      <h1 className="assistant-title">Помощник</h1>
      <p className="assistant-subtitle">
        Инструменты, которые помогают в работе. Со временем их станет больше.
      </p>

      <ul className="assistant-grid">
        {ASSISTANT_SERVICES.map(service => (
          <li key={service.id}>
            <Link to={service.path} className="assistant-tile">
              <span
                className="assistant-tile__icon"
                style={{ background: service.color }}
              >
                <Icon icon={service.icon} width={30} height={30} aria-hidden />
              </span>
              <span className="assistant-tile__label">{service.label}</span>
            </Link>
          </li>
        ))}
      </ul>
    </div>
  </div>
)

export default AssistantPage
